import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const BackToPreviousPage = ({ previousPage, label }) => {
  return (
    <Link to={previousPage} className='breadCrumbLink'>
      {label}
    </Link>
  );
};

BackToPreviousPage.propTypes = {
  previousPage: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default BackToPreviousPage;
